export const api = {
  submitArticle: "api/submit_article",
  calData: "api/cal_data",
  searchNumber: "api/search_number",
  searchResults: "api/search_results",
  getConfig:"api/get_config",
  deleteRecord:"api/deleteRecord"
};
